<script lang="ts">
  import { T, useFrame } from '@threlte/core';
  import fragmentShader from './material/shaders/SuperOrange.frag';
  import vertexShader from './material/shaders/SuperOrange.vert';
  import { BackSide, ShaderMaterial } from 'three';
  import { Colors, Positions, transitionAmount } from '../GradientStore';
  import { CurrentTrack, PlayState } from '../RecordStore';
  import { accessibilityPreferences } from '$lib/stores/accessibility';

  let material: ShaderMaterial;

  let uniforms: any = {
    time: { value: 1.0 },
    colors: { value: $Colors },
    positions: { value: $Positions },
    numColors: { value: $Positions.length },
    transitionColors: { value: $Colors },
    transitionPositions: { value: $Positions },
    numTransitionColors: { value: $Positions.length },
    transitionAmount: { value: 0 }
  };

  //update time every frame
  useFrame((ctx) => {
    if ($accessibilityPreferences.reduceMotion) {
      uniforms.time.value = 0;
    } else {
      uniforms.time.value = ctx.clock.getElapsedTime() / Math.PI;
    }
  });

  //update transitionAmount when value changes
  $: {
    uniforms.transitionAmount = { value: $transitionAmount };
  }

  //update gradient when mood changes
  $: {
    $PlayState, $CurrentTrack, $accessibilityPreferences.reduceColor, transition();
  }

  //transition is async
  const transition = async () => {
    //if it wasn't at 0 fade back to 0;
    if ($transitionAmount > 0) {
      await transitionAmount.set(0, { duration: $transitionAmount * 2000 });
    }
    uniforms.transitionColors.value = $Colors;
    uniforms.transitionPositions.value = $Positions;
    uniforms.numTransitionColors.value = $Positions.length;
    await transitionAmount.set(1, { duration: 2500 });
    //when transition tween is done reset main colors
    uniforms.colors.value = $Colors;
    uniforms.positions.value = $Positions;
    uniforms.numColors.value = $Positions.length;
    //reset transition tween to 0
    transitionAmount.set(0, { duration: 1 });
  };
</script>

<T.Mesh>
  <T.SphereGeometry args={[6, 30, 30]} />
  <T.ShaderMaterial
    bind:ref={material}
    {uniforms}
    {vertexShader}
    {fragmentShader}
    side={BackSide}
  />
</T.Mesh>
